import React, { PropTypes, Component } from 'react'
import classes from './FormGroup.scss'

class FormGroup extends Component {
  static propTypes = {
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    centered: PropTypes.bool,
    inline: PropTypes.bool,
    errorMessage: PropTypes.string
  }

  render () {
    const { id, title, children, centered, inline, errorMessage, style } = this.props
    return (
      <div id={id} style={style} className={centered && 'text-center'}>
        <div className={`${classes.formGroup} ${centered && 'inline-block'}`}>
          <div className={inline && classes.inline}>
            <strong className={classes.title}>{title}</strong>
            {Boolean(errorMessage) && (
              <div className={classes.error}>
                <div className={classes.icon}>
                  <div className={classes.iconColor}>!</div>
                </div>
                <div className={classes.errorMessage}>{errorMessage}</div>
              </div>
            )}
          </div>
          {children}
        </div>
      </div>
    )
  }
}

export default FormGroup



/** WEBPACK FOOTER **
 ** ./src/components/FormGroup.js
 **/